import { FormikErrors, setIn } from 'formik';
import { EnumUserType } from 'lib/graphql';

export type CustomerFormValues = {
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
  company: string;
  address_street: string;
  address_street2: string;
  address_city: string;
  address_state: string;
  address_postcode: string;
  type?: EnumUserType;
  relationships?: {
    producerId?: string;
  };
};

const EMAIL_REGEX =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[A-Za-z0-9-]+(?:\.[A-Za-z0-9-]+)+$/;
const ZIP_REGEX = /^(\d{5})(?:-\d{4})?$/;

export function validateCustomerForm(
  values: CustomerFormValues,
): FormikErrors<CustomerFormValues> {
  let errors: FormikErrors<CustomerFormValues> = {};

  // Required fields
  if (!values.first_name?.trim()) {
    errors.first_name = 'Required';
  }
  if (!values.last_name?.trim()) {
    errors.last_name = 'Required';
  }

  // Either email or phone is required
  const trimmedEmail = values.email?.trim();
  const trimmedPhone = values.phone?.trim();
  const hasEmail = Boolean(trimmedEmail);
  const hasPhone = Boolean(trimmedPhone);

  if (!hasEmail && !hasPhone) {
    errors.email = 'Email or phone is required';
    errors.phone = 'Email or phone is required';
  } else {
    // If email is provided, validate it
    if (hasEmail && !EMAIL_REGEX.test(trimmedEmail!)) {
      errors.email = 'Enter a valid email address';
    }
    // If phone is provided, validate it (must be 10 digits)
    if (hasPhone && trimmedPhone!.length !== 10) {
      errors.phone = 'Must be 10 digits';
    }
  }

  // Validate ZIP code format
  if (
    values.address_postcode &&
    !ZIP_REGEX.test(values.address_postcode.trim())
  ) {
    errors.address_postcode = 'Invalid ZIP';
  }

  // Buyer must have a producer
  if (values.type === EnumUserType.Buyer && !values.relationships?.producerId) {
    errors = setIn(errors, 'relationships.producerId', 'Required');
  }

  return errors;
}
